
export default {
  props: {
    edu: {
      type: Object,
      required: true
    }
  }
}
